import React, { useState } from 'react';

function LoginForm({ onSubmit, loading, error }) {
  const [identity, setIdentity] = useState('');
  const [password, setPassword] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    await onSubmit(identity.trim(), password);
  };

  return (
    <div className="card mt-4">
      <div className="card-body p-4">
        <div className="text-center mt-2">
          <h5 className="text-primary">Welcome Back!</h5>
          <p className="text-muted mb-0">Sign in with your username or email.</p>
        </div>

        <div className="p-2 mt-4">
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={submit} autoComplete="off" noValidate>
            <div className="mb-3">
              <label htmlFor="identity" className="form-label">
                Username or Email
              </label>
              <input
                type="text"
                className="form-control"
                id="identity"
                placeholder="Enter username or email"
                value={identity}
                onChange={(event) => setIdentity(event.target.value)}
                autoComplete="username"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label" htmlFor="password-input">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter password"
                id="password-input"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            <div className="mt-4">
              <button className="btn btn-success w-100" type="submit" disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
